module.exports = "/fonts/HelveticaNeueLightItalic.woff?c3030a2e1288d1a8ab3953e565d91c29";